export default {"src":"/_next/static/media/ic-check.b597204b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};